import React, { useState } from 'react';
import AdminLayout from '../../components/AdminLayout/AdminLayout';
import Pagination from '../../components/Pagination/Pagination';
import './AdminVerificationManagePage.css';

const AdminVerificationManagePage = () => {
  const [activeTab, setActiveTab] = useState('pending');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const verificationRequests = [
    { id: 1, company: 'ABC Construction LLC', email: 'abc@example.com', type: 'Verified', documents: 3, submittedDate: '2025-01-15', status: 'Pending' },
    { id: 2, company: 'XYZ Steel Works', email: 'xyz@example.com', type: 'Inspected', documents: 5, submittedDate: '2025-01-14', status: 'Under Review' },
    { id: 3, company: 'BuildRight Materials', email: 'build@example.com', type: 'Certified', documents: 8, submittedDate: '2025-01-13', status: 'Approved' },
    { id: 4, company: 'Concrete Plus Ltd', email: 'concrete@example.com', type: 'Verified', documents: 3, submittedDate: '2025-01-12', status: 'Rejected' },
    { id: 5, company: 'Gulf Paints Co', email: 'gulf@example.com', type: 'Inspected', documents: 5, submittedDate: '2025-01-11', status: 'Pending' },
    { id: 6, company: 'Steel Dynamics', email: 'steel@example.com', type: 'Certified', documents: 8, submittedDate: '2025-01-10', status: 'Under Review' },
  ];

  const verificationTypes = [
    { name: 'Verified', price: '$99/year', description: 'Document verification only', icon: '✓', count: 245 },
    { name: 'Inspected', price: '$249/year', description: 'On-site inspection + documentation', icon: '🔍', count: 89 },
    { name: 'Certified', price: '$499/year', description: 'Full verification package', icon: '🏆', count: 45 },
  ];

  const getStatusClass = (status) => {
    switch (status) {
      case 'Pending': return 'status-pending';
      case 'Under Review': return 'status-review';
      case 'Approved': return 'status-approved';
      case 'Rejected': return 'status-rejected';
      default: return '';
    }
  };

  const getTypeClass = (type) => {
    switch (type) {
      case 'Verified': return 'type-verified';
      case 'Inspected': return 'type-inspected';
      case 'Certified': return 'type-certified';
      default: return '';
    }
  };

  const filteredRequests = verificationRequests.filter(req => {
    if (activeTab === 'all') return true;
    if (activeTab === 'pending') return req.status === 'Pending';
    if (activeTab === 'review') return req.status === 'Under Review';
    if (activeTab === 'approved') return req.status === 'Approved';
    if (activeTab === 'rejected') return req.status === 'Rejected';
    return true;
  });

  return (
    <AdminLayout>
      <div className="admin-verification-content">
        <div className="verification-page-header">
          <div className="verification-title-section">
            <h1 className="verification-page-title">Verification Management</h1>
            <p className="verification-page-description">Review and manage supplier verification requests</p>
          </div>
        </div>

        {/* Verification Types Cards */}
        <div className="verification-types-grid">
          {verificationTypes.map((type, index) => (
            <div key={index} className={`verification-type-card ${type.name.toLowerCase()}`}>
              <div className="type-icon">{type.icon}</div>
              <div className="type-info">
                <h3 className="type-name">{type.name}</h3>
                <p className="type-price">{type.price}</p>
                <p className="type-description">{type.description}</p>
              </div>
              <div className="type-count">{type.count} Active</div>
            </div>
          ))}
        </div>

        {/* Filter Tabs */}
        <div className="verification-filters">
          <div className="filter-tabs">
            <button 
              className={`filter-tab ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => setActiveTab('all')}
            >
              All Requests
            </button>
            <button 
              className={`filter-tab ${activeTab === 'pending' ? 'active' : ''}`}
              onClick={() => setActiveTab('pending')}
            >
              Pending
            </button>
            <button 
              className={`filter-tab ${activeTab === 'review' ? 'active' : ''}`}
              onClick={() => setActiveTab('review')}
            >
              Under Review
            </button>
            <button 
              className={`filter-tab ${activeTab === 'approved' ? 'active' : ''}`}
              onClick={() => setActiveTab('approved')}
            >
              Approved
            </button>
            <button 
              className={`filter-tab ${activeTab === 'rejected' ? 'active' : ''}`}
              onClick={() => setActiveTab('rejected')}
            >
              Rejected
            </button>
          </div>
          <div className="verification-search">
            <input 
              type="text" 
              placeholder="Search by company..." 
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z" stroke="#64748B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>

        {/* Requests Table */}
        <div className="verification-table-container">
          <table className="verification-table">
            <thead>
              <tr>
                <th>Company</th>
                <th>Email</th>
                <th>Verification Type</th>
                <th>Documents</th>
                <th>Submitted</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredRequests.map((request) => (
                <tr key={request.id}>
                  <td className="company-name">{request.company}</td>
                  <td>{request.email}</td>
                  <td>
                    <span className={`type-badge ${getTypeClass(request.type)}`}>
                      {request.type}
                    </span>
                  </td>
                  <td>{request.documents} files</td>
                  <td>{request.submittedDate}</td>
                  <td>
                    <span className={`status-badge ${getStatusClass(request.status)}`}>
                      {request.status}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button className="action-btn view-btn" title="View Documents">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                          <path d="M1 8C1 8 3.5 3 8 3C12.5 3 15 8 15 8C15 8 12.5 13 8 13C3.5 13 1 8 1 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </button>
                      {request.status === 'Pending' || request.status === 'Under Review' ? (
                        <>
                          <button className="action-btn approve-btn" title="Approve">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M13.3334 4L6.00008 11.3333L2.66675 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </button>
                          <button className="action-btn reject-btn" title="Reject">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                          </button>
                        </>
                      ) : null}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <Pagination currentPage={currentPage} totalPages={3} onPageChange={setCurrentPage} />
      </div>
    </AdminLayout>
  );
};

export default AdminVerificationManagePage;
